import { SlateLogo } from '@carvana/ds-icons';
import React from 'react';
import styles from './slate-footer.module.css';

const SlateFooter: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <SlateLogo className={styles.logo} color="currentColor" />
      <p className={styles.copyright}>
        Copyright © {new Date().getFullYear()} Carvana, LLC. All Rights Reserved.
      </p>
    </footer>
  );
};

export default SlateFooter;
